import { Stamp } from 'lucide-react'
import { useI18n } from '../i18n/useI18n'

/**
 * スタンプ獲得演出 (#1126)。既存の animate-scale-in / animate-fade-in のみで構成
 * （アニメーションライブラリは追加しない — ProcessingOverlay と同じ方針）。
 */
export default function StampSuccessAnimation() {
  const { t } = useI18n()
  return (
    <div className="flex flex-col items-center">
      <div className="relative w-28 h-28 mb-4">
        <div className="absolute inset-0 rounded-full bg-matcha/20 animate-ping" />
        <div className="relative w-28 h-28 rounded-full bg-matcha flex items-center justify-center text-white animate-scale-in shadow-lg">
          <Stamp size={52} />
        </div>
      </div>
      <p className="font-display text-2xl text-navy animate-fade-in">{t('stampRally.gotStamp')}</p>
    </div>
  )
}
